import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

const People = (props) => {
    const { people, onChangeMaskVisible, onChangeCurrentVideo } = props;

    const openVideo = (type) => {
        if (type === 'prev') {
            onChangeCurrentVideo({
                url: people.video_1,
                duration: people.video_1_duration,
                guid: people.video_1_guid,
            });
        } else {
            onChangeCurrentVideo({
                url: people.video_2,
                duration: people.video_2_duration,
                guid: people.video_2_guid,
            });
        }
        onChangeMaskVisible(true);
    };

    return (
        <div className={Style.peopleDetail}>
            {/* <div className={Style.bc} style={personStyle}></div> */}
            <img className={Style.bc} src={formatImageWebpAuto(people.largeImage, 1920, 914)} />
            <div className={`${Style.text} ${people.position === 'right' ? Style.right : ''}`}>
                <div className={Style.peopleInfo}>
                    <div className={Style.name}>{people.name}</div>
                    <div className={Style.desc}>{people.desc}</div>
                    <div className={Style.say}>
                        <div className={Style.left} />
                        {people.say}
                        <div className={Style.right} />
                    </div>
                </div>
                <div className={Style.videos}>
                    <div className={Style.video}>
                        {people.video_1 && (
                            <div onClick={() => openVideo('prev')}>
                                <img src={require('@src/common/assets/play.png')} alt="" />
                                <span>点击播放</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

People.propTypes = {
    people: PropTypes.object,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
};

export default errorBoundary(People);
